module.exports = __webpack_public_path__ + "img/元素3.bc8c4ed2.png";